import { Space } from 'antd';
import { useContext, useMemo } from 'react';

import { CLIENTS_FILTER } from '@app/constants';
import { useMemoizeObject } from '@app/hooks';
import { CHF_TAG_IDS } from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

export const ClientsTagsLabel = ({
  includedFiltersIndex,
}: {
  includedFiltersIndex: number;
}) => {
  const {
    filters,
    serverFilters,
    tagIncludingStatuses,
    memoizedServerFilters,
    setFilters,
    setServerFilters,
    clearGroupBothTagArrays,
    getClientTagsIncluding,
  } = useContext(ClientFiltersContext);

  const memoizedTagIncludingStatuses = useMemoizeObject(tagIncludingStatuses);

  const tagIds = useMemo(() => {
    const excludedFiltersIndex = includedFiltersIndex - 1;
    const dynamicIndex = getClientTagsIncluding(
      includedFiltersIndex,
      memoizedTagIncludingStatuses || []
    )
      ? includedFiltersIndex
      : excludedFiltersIndex;

    return (
      memoizedServerFilters[CLIENTS_FILTER]?.[dynamicIndex]?.Values?.[0]
        ?.TagIds || []
    );
  }, [
    includedFiltersIndex,
    memoizedServerFilters,
    memoizedTagIncludingStatuses,
    getClientTagsIncluding,
  ]);

  return (
    <Space
      className={`clients-tags-label${includedFiltersIndex}`}
      direction="vertical"
    >
      <span>Теги клиентов</span>
      {tagIds?.length > 0 && (
        <ClientFilterTag
          filters={filters}
          serverFilters={serverFilters}
          filtersArea={CLIENTS_FILTER}
          filterGroupIndex={includedFiltersIndex}
          setFilters={setFilters}
          setServerFilters={setServerFilters}
          valueKey={CHF_TAG_IDS}
          handleTagDeletion={() =>
            clearGroupBothTagArrays(includedFiltersIndex)
          }
        >
          <>
            {getClientTagsIncluding(includedFiltersIndex, tagIncludingStatuses)
              ? 'Включено'
              : 'Исключено'}
            : {`${tagIds.length}`}
          </>
        </ClientFilterTag>
      )}
    </Space>
  );
};
